import React, { useState, useContext, useEffect } from "react";
import axios from "axios";

import { useSnackbar } from "notistack";
import Slide from "@material-ui/core/Slide";
import LinearProgress from "@material-ui/core/LinearProgress";
import Alert from "@material-ui/lab/Alert";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import bannerImage1 from "../../assets/images/bannerImage1.png";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { Link, useHistory } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
const useStyles = makeStyles(() => ({
  root: {
    height: "100vh",
    background: "white",
  },
  paddingStyle: {
    padding: "0px 80px",
  },
  marginBottomStyle2: {
    marginBottom: "35px",
  },
  fontStyle: {
    fontSize: "14px",
  },
  rightAlign: {
    textAlign: "right",
    fontWeight: 600,
  },
  label: {
    fontSize: "14px",
  },
  buttonStyle: {
    padding: "10px 32px",
    fontSize: "16px",
    color: "white",
    fontWeight: 600,
    textTransform: "capitalize",
    borderRadius: "4px",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
  },
  muteColor: {
    color: "#19181666",
  },
  divStyle: {
    width: "70%",
    margin: "auto",
    "& img": {
      maxWidth: "100%",
    },
  },
  fieldWrapper: {
    "& .MuiOutlinedInput-inputMarginDense": {
      padding: 15,
    },
  },
  linkStyle: {
    textDecoration: "none",
  },
  banner: {
    marginLeft: 90,
  },
  error: {
    marginBottom: 15,
  },
}));
const Login = () => {
  const classes = useStyles();
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [values, setValues] = React.useState({
    amount: "",
    email: "",
    password: "",
    weight: "",
    weightRange: "",
    showPassword: false,
  });
  const { login, glob_pay_agent_auth } = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };
  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleCheckBox = () => {
    setRememberMe(!rememberMe);
  };
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let data = {
        email: values.email,
        password: values.password,
        grant_type: "password",
        client_id: "mobile-app",
        client_secret: process.env.REACT_APP_SECRET,
        scope: "openid profile",
      };
      let response = await axios({
        url: "/api/v1/public/auth/signin",
        method: "post",
        data: data,
      });
      login(response.data.data);
      history.push("/home");
    } catch (error) {
      console.log("error ", error.response);
      let er = error.response && error.response.data.errors.toString();

      enqueueSnackbar(er, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
        TransitionComponent: Slide,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (glob_pay_agent_auth.access_token) {
      history.push("/");
    }
  }, []);

  return (
    <div>
      <Grid
        container
        direction="column"
        justifyContent="space-between"
        className={classes.root}
      >
        <Grid>
          <Header />
        </Grid>
        <Grid>
          <Grid container alignItems="center" className={classes.paddingStyle}>
            <Grid item xs={6}>
              <div
                className={classes.divStyle}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <img src={bannerImage1} alt="" className={classes.banner} />
              </div>
            </Grid>
            <Grid item xs={6}>
              <div className={classes.divStyle}>
                <Typography variant="h3" className={classes.marginBottomStyle2}>
                  Login as Agent
                </Typography>

                <form onSubmit={handleLogin}>
                  <Grid container alignItems="center" spacing={3}>
                    <Grid item xs={12}>
                      <Typography className={classes.fontStyle} gutterBottom>
                        Email
                      </Typography>
                      <TextField
                        id="email"
                        fullWidth
                        size="small"
                        type="email"
                        required
                        variant="outlined"
                        placeholder="contact@example.com"
                        className={classes.fieldWrapper}
                        value={values.email}
                        onChange={handleChange("email")}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography className={classes.fontStyle} gutterBottom>
                        Password
                      </Typography>
                      <FormControl
                        className={clsx(classes.margin, classes.textField)}
                        variant="outlined"
                        fullWidth
                        size="small"
                      >
                        <OutlinedInput
                          className={classes.fieldWrapper}
                          placeholder="Enter password"
                          id="outlined-adornment-password"
                          required
                          type={values.showPassword ? "text" : "password"}
                          value={values.password}
                          onChange={handleChange("password")}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                              >
                                {values.showPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={7}>
                      <FormControlLabel
                        classes={{ label: classes.label }}
                        control={
                          <Checkbox
                            checked={rememberMe}
                            onChange={handleCheckBox}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Remember this device"
                      />
                    </Grid>
                    <Grid item xs={5}>
                      <Link to="/forgot-password" className={classes.linkStyle}>
                        <Typography
                          color="primary"
                          className={`${classes.fontStyle} ${classes.rightAlign}`}
                        >
                          Forgot Password?
                        </Typography>
                      </Link>
                    </Grid>
                    <Grid item xs={12}>
                      {loading ? <LinearProgress /> : null}

                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        type="submit"
                        className={classes.buttonStyle}
                        disabled={loading}
                      >
                        LOGIN
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid>
          <Footer />
        </Grid>
      </Grid>
    </div>
  );
};
export default Login;
